import { createFileRoute } from '@tanstack/react-router';
import { Assistant } from '@/components/Assistant';

export const Route = createFileRoute('/_auth/assistant')({
  component: AssistantRoute,
});

function AssistantRoute() {
  return <Assistant />;
}
